<template>
  <div v-loading="isBusy">
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        element-loading-spinner="el-icon-loading"
        label-width="170px"
    >
      <el-form-item label="IP Address" prop="ip">
        <el-input v-model="form.ip"></el-input>
      </el-form-item>
    </el-form>
    <button class="btn btn-purple px-4" @click="store">Store</button>
  </div>
</template>

<script>
import BaseForm from '../form';

export default {
  extends: BaseForm,

  data() {
    const form = {
      ip: null,
    };

    return {
      form,
      rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
    }
  },

  methods: {
    /**
     * @param {Object} model
     */
    initForm(model) {
      this.form = _.mapValues(this.form, (val, prop) => _.get(model, prop, null));
    },
  },
}
</script>
